module.exports = __webpack_public_path__ + "assets/info_white.75a9be3e.svg";